const lang = {
  breadcrumb: {
    detail: '登録申請候補詳細',
  },
  page_title: '登録申請候補詳細',
  form_export: '申請書出力',
  adjustment: '調整',
  message: {
    no_application_data: '申請書の登録データがありません。',
  },
}

export default lang
